// extracted by mini-css-extract-plugin
module.exports = {"userDetails":"styles_userDetails__3ME_2","placeholder":"styles_placeholder__3ZugW"};